import { useEffect, useRef } from 'react'
import { HashRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Container } from 'react-bootstrap'
import Header from './components/Header'
import Footer from './components/Footer'

import HomeScreen from './screens/HomeScreen'
import LoginScreen from './screens/LoginScreen'
import RegisterScreen from './screens/RegisterScreen'
import ProfileScreen from './screens/ProfileScreen'
import UserListScreen from './screens/UserListScreen'
import UserEditScreen from './screens/UserEditScreen'
import CourseScreen from './screens/CourseScreen'
import SectionDetailScreen from './screens/SectionDetailScreen'
import QuizScreen from './screens/QuizScreen'

// Fade-slide transition wrapper — no external library needed
function AnimatedRoutes() {
  const location = useLocation()
  const ref = useRef(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    el.classList.remove('page-enter-active')
    el.classList.add('page-enter')
    const frame = requestAnimationFrame(() => {
      el.classList.add('page-enter-active')
      el.classList.remove('page-enter')
    })
    return () => cancelAnimationFrame(frame)
  }, [location.pathname])

  return (
    <div ref={ref}>
      <Routes location={location}>
        <Route path="/"                      element={<HomeScreen />} exact />
        <Route path="/login"                 element={<LoginScreen />} />
        <Route path="/register"              element={<RegisterScreen />} />
        <Route path="/profile"               element={<ProfileScreen />} />
        <Route path="/course"                element={<CourseScreen />} />
        <Route path="/section/:id"            element={<SectionDetailScreen />} />
        <Route path="/quiz/:sectionId"        element={<QuizScreen />} />
        <Route path="/admin/userList"        element={<UserListScreen />} />
        <Route path="/admin/user/:id/edit"   element={<UserEditScreen />} />
      </Routes>
    </div>
  )
}

function App() {
  return (
    <Router>
      <Header />
      <main className='py-3 app-main'>
        <Container>
          <AnimatedRoutes />
        </Container>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
